import { createAsyncThunk } from '@reduxjs/toolkit';
import { SilentThunkError } from '@socialive/common';
import client from '../../../services/api-client';
import selectApiBaseUrl from '../../env/selectors/selectApiBaseUrl';

export default createAsyncThunk('connectionManager/fetchTrayUserId', async (payload, { getState }) => {
  const { accountId } = payload;
  const apiBaseUrl = selectApiBaseUrl(getState());

  const findTrayUserUrl = `${apiBaseUrl}/workflows/find-user-by-account/${accountId}`;
  const findUserResponse = await client(findTrayUserUrl);
  let trayUserId = findUserResponse?.data?.users?.edges?.[0]?.node?.id;
  if (trayUserId) return trayUserId;

  const createTrayUserUrl = `${apiBaseUrl}/workflows/create-user/${accountId}`;
  const createUserResponse = await client(createTrayUserUrl, { method: 'POST' });
  trayUserId = createUserResponse?.data?.createExternalUser?.userId;

  if (!trayUserId) {
    throw new SilentThunkError('tray user id cannot be processed');
  }

  return trayUserId;
});
